import { BaseModuleI } from "../../interfaces";

export const generatePad = (id: number) => {
  return id.toString().padStart(8, "0");
};

export function separator(numb: string) {
  var str = numb.toString().split(".");
  str[0] = str[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  return str.join(".");
}

export const generateRandomPassword = () => {
  const chars = "0123456789abcdefghjkmnopqrstuvwxyzABCDEFGHJKMNOPQRSTUVWXYZ";
  const passwordLength = 7;
  let password = "";
  for (let i = 0; i <= passwordLength; i++) {
    const randomNumber = Math.floor(Math.random() * chars.length);
    password += chars.substring(randomNumber, randomNumber + 1);
  }
  return password;
};

export const collectAccessibleRoutes = (
  modules: BaseModuleI[],
  basePath: string = ""
): string[] => {
  const routes: string[] = [];

  for (const module of modules) {
    const modulePath = module.to || basePath;

    if (module.options) {
      const newRoutes = module.options
        .filter((option) => option.show)
        .map((option) => {
          const optionTo = option.to.startsWith(modulePath)
            ? option.to.replace(modulePath, "").replace(/^\/+/, "")
            : option.to;
          return optionTo.startsWith("/")
            ? `/${normalizeRoute(optionTo)}`
            : `/${normalizeRoute(
                modulePath && optionTo ? `${modulePath}/${optionTo}` : optionTo
              )}`;
        });
      routes.push(...newRoutes);
    }

    if (module.children && module.children.length > 0) {
      const childRoutes = collectAccessibleRoutes(module.children, modulePath);
      routes.push(...childRoutes);
    }

    if (
      module.to &&
      (!module.options || module.options.length === 0) &&
      (!module.children || module.children.length === 0)
    ) {
      const leafRoute = `/${normalizeRoute(module.to)}`;
      routes.push(leafRoute);
    }
  }

  return routes;
};

const normalizeRoute = (route: string): string => {
  return route.replace(/\/+/g, "/").replace(/^\/|\/$/g, "");
};

export const generateUsername = (firstName: string, lastName: string): string => {
  const clean = (str: string) =>
    str
      .toLowerCase()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "") // quita tildes
      .replace(/[^a-z0-9]/g, "");      // solo letras y números
 
  const base = `${clean(firstName)}${clean(lastName)}`;
  const suffix = Math.floor(Math.random() * 90000 + 10000).toString(); // 5 dígitos
  const full = `${base}${suffix}`;
 
  return full.slice(0, 20);
};

export async function validateServiceWorker(): Promise<boolean> {
  try {
    if (process.env.NODE_ENV === "development") {
      console.log("🔧 Desarrollo: Service Worker no disponible");
      return false;
    }

    // Verificar que Service Worker esté registrado
    if (!navigator.serviceWorker) return false;

    // Esperar a que esté ready (importante en móviles)
    const registration = await navigator.serviceWorker.ready;
    if (!registration || !registration.active) return false;

    // Verificar que tengamos un controller activo
    if (!navigator.serviceWorker.controller) {
      // En móviles, a veces necesitamos esperar un poco más
      await new Promise((resolve) => setTimeout(resolve, 100));
      return !!navigator.serviceWorker.controller;
    }

    return true;
  } catch (error) {
    console.warn("❌ Error validando Service Worker:", error);
    return false;
  }
}